import { useTranslation } from 'language/translator'

export function useWidgetLoadingTitles() {
  const { t } = useTranslation()

  return [
    t('loading', 'collecting_data'),
    t('loading', 'syncing_processing'),
    t('loading', 'performing_calculations'),
    t('loading', 'simplifying_data'),
    t('loading', 'presenting_data')
  ]
}

export function useMetricLoadingTitles() {
  const { t } = useTranslation()

  return [
    t('loading', 'collecting_data'),
    t('loading', 'loading_metrics'),
    t('loading', 'analyzing_metrics')
  ]
}
